// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/vue/js/" + chunkId + "-legacy." + {"302":"71d1802b","564":"c57e2de8","645":"6b4ae397","881":"54b47df2","897":"81be7e59","971":"bc06a611","974":"997ba83b"}[chunkId] + ".js";
};